import { render, staticRenderFns } from "./GeneralAmount.vue?vue&type=template&id=46888982&scoped=true"
import script from "./GeneralAmount.vue?vue&type=script&lang=ts"
export * from "./GeneralAmount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46888982",
  null
  
)

export default component.exports